import { render, staticRenderFns } from "./ErrorPopupComponent.vue?vue&type=template&id=0cc73808"
import script from "./ErrorPopupComponent.vue?vue&type=script&lang=js"
export * from "./ErrorPopupComponent.vue?vue&type=script&lang=js"
import style0 from "./ErrorPopupComponent.vue?vue&type=style&index=0&id=0cc73808&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports